import { ActionTree, MutationTree } from 'vuex'
import { getBrandLoyalty, getProgramLoyalty, getLoyaltyResult } from './api'
import { ILoyaltyAction, ILoyaltyActionsTypes, ILoyaltyMutation, ILoyaltyMutationTypes, ILoyaltyState } from './interfaces'
import { IRootState } from '@/store'

const state = () => ({
  loading: false,
  program: {},
  brands: [],
  results: []
})

const mutations: MutationTree<ILoyaltyState> & ILoyaltyMutation = {
  [ILoyaltyMutationTypes.SET_LOADING] (state, payload: boolean): void {
    state.loading = payload
  },
  [ILoyaltyMutationTypes.SET_LOYALTY_PROGRAM] (state, payload: any): void {
    state.program = payload
  },
  [ILoyaltyMutationTypes.SET_LOYALTY_BRAND] (state, payload: any): void {
    state.brands = payload
  },
  [ILoyaltyMutationTypes.SET_RESULT] (state, payload: any): void {
    state.results = payload
  }
}

const actions: ActionTree<ILoyaltyState, IRootState> & ILoyaltyAction = {

  async [ILoyaltyActionsTypes.FETCH_LOYALTY_PROGRAM] ({ commit }) {
    commit(ILoyaltyMutationTypes.SET_LOADING, true)
    const data = await getProgramLoyalty()
    if (data?.results) {
      commit(ILoyaltyMutationTypes.SET_LOYALTY_PROGRAM, data?.results[0])
    }
    commit(ILoyaltyMutationTypes.SET_LOADING, false)
    // commit(BasketMutationTypes.SET_LOADING, true)
    // const { data } = await apolloClient.query<IFetchBasketResponse, IFetchBasketRequest>({
    //   query: fetchCustomerBasketQuery
    // })
    // try {
    //   if (data) {
    //     commit(BasketMutationTypes.SET_BASKET_ID, data?.customerCart.id)
    //     commit(BasketMutationTypes.SET_LOADING, false)
    //   }
    // } catch (error) {
    //   commit(BasketMutationTypes.SET_LOADING, false)
    //   commit(BasketMutationTypes.SET_ERROR, error as IError[])
    //   console.error('fetch basket error', error)
    // }
  },
  async [ILoyaltyActionsTypes.FETCH_LOYALTY_BRAND] ({ commit }) {
    commit(ILoyaltyMutationTypes.SET_LOADING, true)
    const data = await getBrandLoyalty()
    if (data?.results) {
      commit(ILoyaltyMutationTypes.SET_LOYALTY_BRAND, data?.results)
    }
    commit(ILoyaltyMutationTypes.SET_LOADING, false)
  },
  async [ILoyaltyActionsTypes.FETCH_LOYALTY_RESULT] ({ commit }, dto) {
    commit(ILoyaltyMutationTypes.SET_LOADING, true)
    const res = await getLoyaltyResult(dto)
    if (res?.data) {
      commit(ILoyaltyMutationTypes.SET_RESULT, res.data)
    }
    commit(ILoyaltyMutationTypes.SET_LOADING, false)
  }
}

const LoyaltyModule = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default LoyaltyModule
